import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ButtonLink } from './ButtonLink';
import { SubmitButton } from './AuthenticationForm/SubmitButton';

const styles = (theme) => ({
  submitWrapper: {
    margin: '0 auto',
    width: '200px',
    marginTop: '25px',
  },
  wrapper: {
    marginTop: '25px',
  },
});

const ConfirmLogoutTabComponent = ({
  classes,
  handleTabChange,
  title,
  subtext,
  message,
  user,
  logout,
  onClose,
  ...props
}) => (
  <div className={`${classes.wrapper} ${classes.tabContainer}`}>
    <p className={classes.subtext}>Are you sure you want to logout?</p>
    <div className={classes.submitWrapper}>
      <SubmitButton onClick={onClose}>Stay logged in</SubmitButton>
    </div>
    <div className={classes.cancelBtn}>
      <ButtonLink onClick={logout}>Logout</ButtonLink>
    </div>
  </div>
);
ConfirmLogoutTabComponent.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  handleTabChange: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};

export const ConfirmLogoutTab = withStyles(styles)(ConfirmLogoutTabComponent);
